import React, {useContext, useState} from "react";
import { Col, Container, Row } from "react-bootstrap";
import BasketList from "../components/Basket/BasketList";
import BasketConfirm from "../components/Basket/BasketConfirm";
import BasketCheckout from "../components/Basket/BasketCheckout";
import {Context} from "../index";
import EmptyBasket from "../components/Basket/EmptyBasket";


const Basket = () => {
    const { product } = useContext(Context)

    const initialFormState ={
        //  https://www.youtube.com/watch?v=bfQ2LZ-rWRg&list=WL&index=25
    }

    const [customerData, setCustomerData] = useState({
            recipient: {firstName:'', lastName:'', phone:'', email:''},
        /*    fullName:'',
            lastName:'',
            email:'',
            phone:'',*/
            address: { value: '', data: { city: '', street_with_type: '', house: '', block_type: '', block: '', padik: '', flat: '', geo_lat: '',  geo_lon: '' } },
            city:'',
            house:'',
            street:'',
            padik:'',
            flat:'',
            priceDost:'',
            comment:''           
      });

        const [errors, setErrors] = useState({
            recipient: {firstName:'', phone:'', email:''},
           /* fullName:'',
            email:'',
            phone:'',*/
            address: { value: '', data: { city: '', street_with_type: '', house: '', block_type: '', block: '', padik: '', flat: ''} },
            city:'',
            house:'',
            street:''
        });
        const [isFormValid, setIsFormValid] = useState(true);


        // console.log("customerData for Basket", customerData)
        return (
        <>
            {product.basketProducts?.length > 0 ? (
                <>
                    <Container>
                        <Row>
                            <Col className="mb-4">
                                <a className="ps-0 pe-3 text-decoration-underline" href="/">Вернуться к покупкам</a>
                            </Col>
                        </Row>
                    </Container>
                    <Container className="checkout pt-4 mb-5">
                        <h1 className="mb-4">Оформление заказа</h1>
                        <Row>
                        <Col xs={12} md={9} className="order-1 order-md-1">
                            <BasketList />
                            <div className="checkout-data mt-4">
                              <BasketCheckout 
                                   customerData={customerData}
                                   setCustomerData={setCustomerData}
                                   errors={errors}
                                   isFormValid={isFormValid}
                              />
                            </div>
                        </Col>
                        <Col xs={12} md={3} className="order-2 order-md-2 mt-4 mt-md-0">
                            <div className="sticky-top total-sticky" style={{zIndex: 100}}>
                              <BasketConfirm 
                                   customerData={customerData}
                                   setErrors={setErrors}
                                   setIsFormValid={setIsFormValid}
                                />
                            </div>
                          </Col>
                        </Row>         
                    </Container>
                </>
            ) : (<EmptyBasket />)}
        </>
    );
};

export default Basket;